import React from 'react';

export default () => (
    <svg viewBox="0 0 100 100">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h86v86H0z" />
            <g transform="translate(12 -1)">
                <path
                    d="M39.375 7.486l-2.454.345c-1.275.179-2.574-.373-3.24-1.473a6.934 6.934 0 0 0-12.627 1.775c-.337 1.24-1.434 2.13-2.71 2.308l-2.453.345a5.83 5.83 0 0 0-4.962 6.586l.615 4.376 35.03-4.923-.615-4.376a5.83 5.83 0 0 0-6.584-4.963z"
                    stroke="#2A4473"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle fill="#FBF2C1" cx="40.645" cy="55.2" r="17.5" />
                <path
                    d="M46.212 12.761l5.711-.802a4.403 4.403 0 0 1 4.973 3.748l7.92 56.347a4.403 4.403 0 0 1-3.748 4.973l-46.861 6.586a4.403 4.403 0 0 1-4.974-3.747l-7.92-56.347a4.404 4.404 0 0 1 3.749-4.974l5.629-.791"
                    stroke="#2A4473"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.299 50.654c-1.46-10.382 5.774-19.981 16.155-21.44 10.382-1.46 19.98 5.774 21.44 16.156 1.459 10.382-5.774 19.982-16.156 21.441-10.38 1.459-19.98-5.775-21.439-16.157z"
                    stroke="#2A4473"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    stroke="#2A4473"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M31.47 36.445l-3.162 6.752-6.882 2.913 5.466 5.076.645 7.419 6.54-3.614 7.283 1.671-1.424-7.31 3.854-6.385-7.419-.903z"
                />
            </g>
        </g>
    </svg>
);
